import React from "react";
import {
  View,
  Pressable,
  Text,
  Image,
  StyleProp,
  ImageStyle,
  ViewStyle,
  TextStyle,
} from "react-native";
import { createPlatformStyles } from "../../theme/theme";

interface ActionTileProps {
  containerStyle: StyleProp<ViewStyle>;
  containerStyleIds: string;
  onPress: () => void;
  title: string;
  icon: any;
  iconStyle: StyleProp<ImageStyle>;
  iconStyleIds: string;
  textStyle: StyleProp<TextStyle>;
  textStyleIds: string;
}

const ActionTile = ({
  containerStyle,
  containerStyleIds,
  onPress,
  title,
  icon,
  iconStyle,
  iconStyleIds,
  textStyle,
  textStyleIds,
}: ActionTileProps) => {
  return (
    <View style={containerStyle} dataSet={{ media: containerStyleIds }}>
      <Pressable
        onPress={onPress}
        style={styles.tileTouch}
        dataSet={{ media: ids.tileTouch }}
        testID={`action-page-tile-${title?.toLowerCase()?.replaceAll(" ", "-")}`}
      >
        <Text style={textStyle} dataSet={{ media: textStyleIds }} testID={`action-page-tile-${title?.toLowerCase()?.replaceAll(" ", "-")}-label`}>
          {title}
        </Text>
        <Image
          style={iconStyle}
          dataSet={{ media: iconStyleIds }}
          source={icon}
          testID={`action-page-tile-${title?.toLowerCase()?.replaceAll(" ", "-")}-icon`}
        />
      </Pressable>
    </View>
  );
};

export default ActionTile;
export const { ids, styles } = createPlatformStyles({
  mobile: {
    tileTouch: {
      width: "100%",
      height: "100%",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  web: {
    tileTouch: {
      width: "100%",
      height: "100%",
      justifyContent: "center",
      alignItems: "center",
    },
  },
});
